import { getStore, storeKeys } from 'core/storage/store';
import { MemoType, Task } from 'models/Memo';

// Persists the composer's plain fields (not the Doc editor's TipTap document,
// which DraftActor already handles) across remounts — e.g. navigating away to
// Search/Notifications/Settings and back, which unmounts the composer. Only
// one draft is kept per box (whichever type is currently selected), not one
// per type.
export interface ComposerDraftFields {
  type?: MemoType;
  collectionId?: string | null;
  title?: string;
  content?: string;
  description?: string;
  source?: string;
  author?: string | null;
  tasks?: Task[];
  name?: string;
  isAllDay?: boolean;
  isMoment?: boolean;
  startAt?: Date;
  endAt?: Date;
  datedAt?: Date | null;
}

type ComposerDraftsByBox = Record<string, ComposerDraftFields>;

const readAll = (): ComposerDraftsByBox =>
  getStore().getItem(storeKeys.composerDrafts) ?? {};

export const getComposerDraft = (
  boxId: string | undefined,
): ComposerDraftFields | null => {
  if (!boxId) return null;
  return readAll()[boxId] ?? null;
};

export const saveComposerDraft = (
  boxId: string | undefined,
  values: ComposerDraftFields,
) => {
  if (!boxId) return;
  getStore().setItem(storeKeys.composerDrafts, {
    ...readAll(),
    [boxId]: values,
  });
};

export const discardComposerDraft = (boxId: string | undefined) => {
  if (!boxId) return;
  const all = readAll();
  if (!(boxId in all)) return;

  const { [boxId]: _discarded, ...rest } = all;
  getStore().setItem(storeKeys.composerDrafts, rest);
};
